var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['car-list-container']},[_c('div',{class:_vm.$style['car-list-item']},[_c('BaseWorkerItems',{attrs:{"configData":_vm.configDataLeft}})],1),_c('div',{class:_vm.$style['car-list-item']},[_c('BaseWorkerItems',{attrs:{"configData":_vm.configDataRight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }